module.exports = __webpack_public_path__ + "img/feature_buy_zh.52b37203.png";